module.exports = __webpack_public_path__ + "static/media/gifEight.50ec67f5.gif";